import { render, staticRenderFns } from "./events-sports.vue?vue&type=template&id=11857a44"
import script from "./events-sports.vue?vue&type=script&lang=js"
export * from "./events-sports.vue?vue&type=script&lang=js"
import style0 from "./events-sports.vue?vue&type=style&index=0&id=11857a44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports